import React from 'react';
import StripeComponent from '../StripeComponent';
import OrdersList from '../OrdersList';
import EmptyOrder from '../EmptyOrder';

const OrdersScreenComponent = ({
  isShowStripe,
  order,
  totalPrice,
  handleOrder,
  open,
  handleClose,
  stripePromise,
  payment,
  onPaymentSuccess,
  setOrder,
  setPayment,
  onCancelPayment,
  elementsOptions,
}) => {
  if (isShowStripe) {
    return (
      <StripeComponent
        stripePromise={stripePromise}
        payment={payment}
        onPaymentSuccess={onPaymentSuccess}
        onCancelPayment={onCancelPayment}
        totalPrice={totalPrice}
        setOrder={setOrder}
        setPayment={setPayment}
        elementsOptions={elementsOptions}
      />
    );
  }

  if (order.length > 0) {
    return (
      <OrdersList
        order={order}
        totalPrice={totalPrice}
        handleOrder={handleOrder}
        open={open}
        handleClose={handleClose}
      />
    );
  }

  return <EmptyOrder />;
};

export default OrdersScreenComponent;
